import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { changePassword } from "../../../../services/operations/SettingsAPI"
import IconBtn from "../../../common/IconBtn"

export default function UpdatePassword() {
  const { token } = useSelector((state) => state.auth)
  const navigate = useNavigate()

  const [showOldPassword, setShowOldPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const submitPasswordForm = async (data) => {
    // console.log("password Data - ", data)
    try {
      await changePassword(token, data)
    } catch (error) {
      console.log("ERROR MESSAGE - ", error.message)
    }
  }

  const {darkMode} = useSelector((state) => state.mode);

  return (
    <>
      <form onSubmit={handleSubmit(submitPasswordForm)}>
        <div className={`my-10 flex flex-col gap-y-6 rounded-md border-[1px] ${darkMode ? "border-richblack-700 bg-richblack-800" : "bg-white border-pure-greys-50 shadow-[0_3px_10px_rgb(0,0,0,0.2)]"} p-8 px-12`}>
          <h2 className={`text-lg font-semibold ${darkMode ? "text-richblack-5" : "text-richblack-600"}`}>Password</h2>
          <div className="flex flex-col gap-5 lg:flex-row">
            <div className="relative flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="oldPassword" className={`${darkMode ? "label-style" : "light-label-style"}`}>
                Current Password
              </label>
              <input
                type={showOldPassword ? "text" : "password"}
                name="oldPassword"
                id="oldPassword"
                placeholder="Enter Current Password"
                className= {`${darkMode ? "form-style" : "light-form-style border-[1px] border-pure-greys-50"}`}
                {...register("oldPassword", { required: true })}
              />
              <span
                onClick={() => setShowOldPassword((prev) => !prev)}
                className="absolute right-3 top-[38px] z-[10] cursor-pointer"
              >
                {showOldPassword ? (
                  <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
                ) : (
                  <AiOutlineEye fontSize={24} fill="#AFB2BF" />
                )}
              </span>
              {errors.oldPassword && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your Current Password.
                </span>
              )}
            </div>
            <div className="relative flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="newPassword"  className={`${darkMode ? "label-style" : "light-label-style"}`}>
                New Password
              </label>
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                id="newPassword"
                placeholder="Enter New Password"
                className= {`${darkMode ? "form-style" : "light-form-style border-[1px] border-pure-greys-50"}`}
                {...register("newPassword", { required: true })}
              />
              <span
                onClick={() => setShowNewPassword((prev) => !prev)}
                className="absolute right-3 top-[38px] z-[10] cursor-pointer"
              >
                {showNewPassword ? (
                  <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
                ) : (
                  <AiOutlineEye fontSize={24} fill="#AFB2BF" />
                )}
              </span>
              {errors.newPassword && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please enter your New Password.
                </span>
              )}
            </div>

            <div className="relative flex flex-col gap-2 lg:w-[48%]">
              <label htmlFor="confirmNewPassword"  className={`${darkMode ? "label-style" : "light-label-style"}`}>
                Confirm Password
              </label>
              <input 
                name="confirmNewPassword"
                id="confirmNewPassword"
                placeholder="Confirm New Password"
                className= {`${darkMode ? "form-style" : "light-form-style border-[1px] border-pure-greys-50"}`}
                {...register("confirmNewPassword", { required: true })}
              />
               
              {errors.confirmNewPassword && (
                <span className="-mt-1 text-[12px] text-yellow-100">
                  Please Confirm your New Password.
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={() => {
              navigate("/dashboard/my-profile")
            }}
            className={`cursor-pointer rounded-md py-2 px-5 font-semibold  ${darkMode ? "text-richblack-50 bg-richblack-700" : "bg-pure-greys-25 border-[1px] border-pure-greys-50 text-richblack-600"}`}
          >
            Cancel
          </button>
          <IconBtn type="submit" text="Update" />
        </div>
      </form>
    </>
  )
}